import { memo, useCallback, useMemo } from 'react';
import { IconCopyCheck, IconEye, IconEyeOff, IconTrash } from '@tabler/icons-react';
import PlayerMenuTooltip from '../../../PlayerMenus/PlayerMenuTooltip';
import { getTextElementById } from '../utils';
import {
  deleteTextElement,
  toggleCaptions,
  applySelectedTextElementStylesToAllTextElements
} from './textElementPopoverUtils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { showSuccessToast } from '@/libs/toast/toast';

function TextElementActions({ textElementId }: { textElementId: string }) {
  const { clipId, clipData } = useClipsContext();

  const selectedElement = useMemo(() => {
    return getTextElementById(clipData, textElementId);
  }, [clipData, textElementId]);

  const handleToggleCaptions = useCallback(() => {
    toggleCaptions(clipId, clipData, textElementId);
  }, [clipId, clipData, textElementId]);

  const handleDeleteElement = useCallback(() => {
    deleteTextElement(clipId, clipData, textElementId);
  }, [clipId, clipData, textElementId]);

  const handleApplyStylesToAll = useCallback(() => {
    applySelectedTextElementStylesToAllTextElements(clipId, clipData, textElementId);
    showSuccessToast('Styles applied to all callouts');
  }, [clipId, clipData, textElementId]);

  return (
    <>
      <button
        data-testid="text-element-hide-button"
        className="group/button relative flex w-10 cursor-pointer items-center justify-center rounded-md hover:bg-slate-100"
        onClick={handleToggleCaptions}
      >
        {selectedElement.details.areCaptionsHidden ? <IconEye size={16} /> : <IconEyeOff size={16} />}
        <PlayerMenuTooltip content={selectedElement.details.areCaptionsHidden ? 'Show Captions' : 'Hide Captions'} />
      </button>
      <button
        data-testid="text-element-apply-styles-all-button"
        className="group/button relative flex w-10 cursor-pointer items-center justify-center rounded-md hover:bg-slate-100"
        onClick={handleApplyStylesToAll}
      >
        <IconCopyCheck size={16} />
        <PlayerMenuTooltip content={'Apply styles to all callouts'} />
      </button>
      <button
        data-testid="text-element-delete-button"
        className="group/button relative flex w-10 cursor-pointer items-center justify-center rounded-md hover:bg-slate-100 hover:text-red-600"
        onClick={handleDeleteElement}
      >
        <IconTrash size={16} />
        <PlayerMenuTooltip content="Delete Text Element" />
      </button>
    </>
  );
}

export default memo(TextElementActions);
